import { connect } from "react-redux";
import ListChatFlowsComponent from "../../Components/ChatFlows/ListChatFlowsComponent";
import { setChatFlows, setWhatsAppFlows } from "../../Redux/Actions/ChatFlowActions";

const mapStateToProps = (state) => ({
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
  st_ChatFlows: state.reducer.chatFlows,
  st_WhatsAppFlows: state.reducer.whatsAppFlows,
});

const mapDispatchToProps = (dispatch) => ({
  setChatFlows: (chatFlows) => dispatch(setChatFlows(chatFlows)),
  setWhatsAppFlows: (whatsAppFlows) => dispatch(setWhatsAppFlows(whatsAppFlows)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ListChatFlowsComponent);
